module.exports = __webpack_public_path__ + "img/icon_team.8e1c39f3.svg";